import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Api from "../../../lib/componentApi";
import validateForm, { formErrorsMessage } from "../../../lib/validateForm";
import getAppErrors from "../../../lib/appErrors";
import mixpanel from "../../../lib/mixPanel";

import AppErrors from "../../../components/Common/AppErrors";

import LoginForm from "../../../components/Auth/LoginForm";
import RestorePassword from "../../../components/Auth/RestorePassword";
import Signup from "./Signup";
import Facebook from "./WithFacebook";
import { GlobalConsumer } from "../../../context/GlobalContext";
import customUrlSearchParams from "../../../lib/customUrlSearchParams";
import { setUserFbLogin } from "../../../utils/firebase";

class Login extends Component {
  constructor(props) {
    super(props);
    const searchParams = new customUrlSearchParams(props.location.search);
    this.state = {
      password: "",
      email: "",
      formErrors: formErrorsMessage.login,
      signupSection: props.firstSignup,
      emailRequired: false,
      withFacebook: false,
      fbAccessToken: "",
      errorMessage: null,
      active: false,
      checkOut: props.checkOut || searchParams.get("checkout") === "1",
      restorePass:
        (!!searchParams.get("token") && searchParams.get("token")) || null,
      refKey: props.match.params.userRefCode || null,
      showErrors: false,
      returnHome: false
    };
  }
  componentDidMount() {
    const { restorePass } = this.state;
    if (restorePass) {
      Api.post(
        "/api/check/passKey",
        { key: restorePass },
        (response, errors) => {
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
          } else if (response.code) {
            const errorMessage = getAppErrors(response.code);
            this.setState({
              errorMessage:
                (errorMessage && errorMessage.message) || response.message,
              returnHome: true
            });
          }
        }
      );
    }
  }
  handleChange = event => {
    event.preventDefault();
    const input = event.target.id;
    this.setState(
      {
        [input]: event.target.value.trim(),
        showErrors: false
      },
      () => {
        const currentState = { [input]: this.state[input] };
        const inputError = validateForm(currentState, "login");
        const { formErrors } = this.state;
        formErrors[input] = inputError;
        this.setState({ formErrors }, () => {
          const { email, password } = this.state;
          const errors = Object.values(this.state.formErrors).filter(Boolean);
          if (email && password && !errors.length) {
            this.setState({ active: true });
          } else {
            this.setState({ active: false });
          }
        });
      }
    );
  };
  _confirm = (data, event, updateUser) => {
    const token = data.token || "";
    const { checkOut } = this.state;
    const { onClose, location } = this.props;
    if (token) {
      mixpanel.people.set({ "Logged In": true, Platform: "Web" });
      if (updateUser) {
        updateUser({ shouldUpdate: true });
      }
      if (onClose) {
        if (checkOut) {
          onClose("loginSection");
        } else {
          onClose({ token });
        }
      } else {
        if (
          location.state &&
          location.state.from &&
          location.state.from.pathname
        ) {
          const { pathname, search, hash } = location.state.from;
          window.location.href = pathname + search + hash;
        } else {
          window.location.href = "/";
        }
      }
    } else {
      window.location.href = "/login";
    }
  };
  isValid = () => {
    const { email, password } = this.state;
    const errors = Object.values(this.state.formErrors).filter(Boolean);
    if (email && password && !errors.length) {
      return true;
    } else {
      this.setState(
        {
          showErrors: true
        },
        () => {
          return false;
        }
      );
    }
  };
  handleSubmit = (event, updateUser) => {
    event.preventDefault();
    const isValid = this.isValid();
    if (isValid) {
      const { email, password } = this.state;
      Api.post("/api/login", { email, password }, (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          const errorMessage = getAppErrors(response.code);
          if (response.code === 1003) {
            Api.get("/api/logout", {});
          }
          this.setState({
            errorMessage:
              (errorMessage && errorMessage.message) || response.message,
            active: false
          });
        } else {
          this._confirm(response, event, updateUser);
        }
      });
    }
  };
  onClickSignup = () => {
    this.setState({
      signupSection: true
    });
  };
  onCloseSignup = () => {
    this.setState({
      signupSection: false
    });
  };
  onClickClose = () => {
    const { returnHome } = this.state;
    if (returnHome) {
      window.location.href = "/";
    } else {
      this.setState({
        errorMessage: null
      });
    }
  };
  openFacebookForm = ({ emailRequired, fbAccessToken }) => {
    var body = document.body;
    body.classList.add("body-overflow");
    this.setState({
      withFacebook: true,
      emailRequired,
      fbAccessToken
    });
  };
  onCloseFacebookForm = () => {
    this.setState({
      withFacebook: false
    });
  };
  onCloseLogin = () => {
    const { onCloseSection, onClose } = this.props;
    if (onClose) {
      onClose("loginSection");
    } else if (onCloseSection) {
      onClose("loginSection");
    } else {
      window.location.href = "/";
    }
  };
  render() {
    const { onClose, location } = this.props;
    const { pathname } = location;
    const {
      email,
      password,
      checkOut,
      formErrors,
      active,
      signupSection,
      restorePass,
      errorMessage,
      withFacebook,
      emailRequired,
      fbAccessToken,
      refKey,
      showErrors
    } = this.state;
    return (
      (errorMessage && (
        <AppErrors message={errorMessage} onClickClose={this.onClickClose} />
      )) ||
      (signupSection && (
        <Signup
          onCloseForCheckOut={onClose}
          checkOut={checkOut}
          onCloseLogin={this.onCloseLogin}
          onSubmit={this._confirm}
          openFacebookForm={this.openFacebookForm}
          onCloseSection={this.onCloseSignup}
        />
      )) ||
        (withFacebook && (
          <Facebook
            emailRequired={emailRequired}
            onSubmit={this._confirm}
            onCloseSection={this.onCloseFacebookForm}
            fbAccessToken={fbAccessToken}
            refKey={refKey}
          />
        )) ||
        (restorePass && (
          <RestorePassword
            passKey={restorePass}
            handleCloseSection={() => this.setState({ restorePass: "" })}
          />
        )) || (
          <GlobalConsumer>
            {({ updateUser }) => (
              <LoginForm
                email={email}
                password={password}
                checkOut={checkOut}
                onChange={this.handleChange}
                handleSubmit={this.handleSubmit}
                formErrors={formErrors}
                active={active}
                onCloseLogin={this.onCloseLogin}
                onCloseForCheckOut={onClose}
                onClickSignup={this.onClickSignup}
                openFacebookForm={this.openFacebookForm}
                updateUser={updateUser}
                refKey={refKey}
                showErrors={showErrors}
                pathname={pathname}
              />
            )}
          </GlobalConsumer>
        )
    );
  }
}

export default withRouter(Login);
